import * as React from 'react';
import * as _ from 'lodash';
import classNames from 'classnames';
export default function () {
    function onClick1() {
        this.handleChange({ target: { value: '' } });
    }
    return React.createElement('div', { 'className': classNames('app-search', this.props.componentClassName) }, React.createElement('input', {
        'id': 'SearchBar',
        'ref': 'searchInput',
        'placeholder': 'Search',
        'className': 'app-search__input ' + (this.state.value ? ' app-search__input--with-value' : ''),
        'value': this.value(),
        'onChange': this.handleChange
    }), this.state.value ? React.createElement('button', {
        'className': 'ui-icon-close app-search__reset',
        'onClick': onClick1.bind(this),
        'key': '382'
    }) : null);
}